module.exports = __webpack_public_path__ + "img/人像抠图--场景切换.e418e620.png";